import { Typography, Slider as MuiSlider, Stack } from "@mui/material";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { setYears } from "store/wizard";

const Slider = () => {  
  const { years } = useAppSelector((state) => state.wizard);
  const dispatch = useAppDispatch()

  const handleChange = (e: Event, newValue: number | number[]) => {
    let staggerTime = 1000;
    let values = Array.isArray(newValue) ? newValue : [newValue];
    values.forEach((value, index) => {
      setTimeout(() => {
        dispatch(setYears(value as number));
      }, index * staggerTime);
    });
  };

  return (
    <>
      <Typography mt={2} textAlign="center" variant="caption" color="#333" className="d-block">
        How long would you like to offset your emissions for?
      </Typography>
      <Stack spacing={2} direction="row" alignItems="center">
        <Typography textAlign="center" variant="body2" fontWeight={700} className="pe-2">1 year</Typography>
        <MuiSlider 
          value={years} 
          onChange={handleChange}
          min={1}
          max={50}
          valueLabelDisplay="on"
          valueLabelFormat={value => <>{value < 50 ? <>{value} year{value > 1 && "s"}</> : "50 years"}</>}
        />
        <div className="ps-2">
          <Typography textAlign="center" variant="body2" fontWeight={700}>50 years</Typography>
        </div>
      </Stack>
      
    </>
  );
};
export default Slider;
